module.exports = __webpack_public_path__ + "3bcd6f2ba3b73e8d6a6869a0241af331.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/outbreaks_shape.png
 ** module id = 1072
 ** module chunks = 0
 **/